import type { SelfServiceSubmissionRow } from '../../types/selfService';
import { buildFollowUpCampaignName, buildFollowUpDates } from './campaignSharedHelpers';
import { rerunGeoFields } from './rerunGeoFields';

/** Shared `rerunFrom` wizard handoff payload (in-app navigation + email deep links). */
export function buildRerunFromPayload(submission: SelfServiceSubmissionRow) {
  const liveCreatives = (submission.creatives ?? []).filter((c) => c.status === 'active');
  const liveCreative = liveCreatives[0] ?? null;
  const followUpDates = buildFollowUpDates(
    submission.campaign?.startDate,
    submission.campaign?.endDate,
  );
  const followUpName = buildFollowUpCampaignName(
    submission.campaign?.campaignName ?? '',
    followUpDates.startDate,
  );

  return {
    sourceSubmissionId: submission.id,
    formData: {
      businessName: submission.business_info?.businessName ?? '',
      businessWebsite: submission.business_info?.businessWebsite ?? '',
      contactEmail: submission.contact_email,
      contactName: submission.business_info?.contactName ?? '',
      contactPhone: submission.business_info?.contactPhone ?? '',
      campaignName: followUpName,
      budget: submission.campaign?.budget ?? null,
      startDate: followUpDates.startDate,
      endDate: followUpDates.endDate,
      selectedProduct: submission.campaign?.selectedProduct ?? '',
      targetMarkets: submission.campaign?.targetMarkets ?? [],
      ...rerunGeoFields(submission.campaign?.targetMarkets),
    },
    creatives: liveCreatives.map((c) => ({
      storagePath: c.storage_path,
      filename: c.filename,
      mimeType: c.mime_type ?? 'video/mp4',
      sizeBytes: c.size_bytes ?? 0,
      clickThroughUrl: c.click_through_url,
      startDate: undefined,
      endDate: undefined,
    })),
    creativeMeta: liveCreative
      ? {
          storagePath: liveCreative.storage_path,
          filename: liveCreative.filename,
          mimeType: liveCreative.mime_type ?? 'video/mp4',
          sizeBytes: liveCreative.size_bytes ?? 0,
        }
      : undefined,
  };
}
